
import { useDispatch,useSelector } from "react-redux";
import config from "../config";
import {  set_showmeeting, unset_showmeeting} from '../slice/mainslice'
import dayjs from 'dayjs';
import { Group, Grid, Paper,Space, ScrollArea, Button, createStyles, getBreakpointValue, em} from '@mantine/core';
import { User, Activity, Clock } from 'tabler-icons-react';

import intl from "react-intl-universal";
import { useState } from "react";
import React from "react";

const useStyles = createStyles((theme) => ({
  grid_f_size: {

    [`@media (max-width: ${em(getBreakpointValue(theme.breakpoints.xl) - 1)})`]: {
      fontSize: `10px`,
    },
  },
}));


export function ShowLogs() {
  const { classes } = useStyles();
  const dispatch = useDispatch()
  const logs = useSelector((state: any) => state.user.meetinglogs?.length ? state.user.meetinglogs : []);
  const meetingtitle = useSelector((state: any) => state.user.meetinginfo.title)
  const token = useSelector((state: any) => state.user.token)

  const [pdfloader, setPdfloader] = useState(false);
  const [ziploader, setZiploader] = useState(false);

  const closelog = () => {
    dispatch(unset_showmeeting());
  }

  window.addEventListener('resize', handleWindowResize);
  let screenWidth: number
  let iconsize = 20
  screenWidth = window.innerWidth;
  function handleWindowResize() {
  screenWidth = window.innerWidth;
  }



  const firstLog = logs.length > 0 ? logs[0] : null;
  const drnID = firstLog ? firstLog.drnId : null;
  const meetingId = firstLog ? firstLog.meetingId : null;
  let now = dayjs(new Date());

  const offsetMinutes = new Date().getTimezoneOffset();
  const offsetHours = Math.abs(offsetMinutes) / 60;
  const offsetSign = offsetMinutes < 0 ? '+' : '-';
  const formattedOffset = `${offsetSign}${String(offsetHours)}`;


  
 

  const fetchPdf = async (drnID:any) => {
    
    setPdfloader(true)

    let fetchurl
    try {
    if (config.downloadUrlLog !== undefined) {
        fetchurl = config.downloadUrlLog
     } else {
    fetchurl = "https://notarcms-hub.dev.lilenium.com/api/Meeting/signLogsAndGetPdf?drnId="
    throw new Error ("WS: Keine Docker Umgebunsvariablen gefunden!");
    }
    } catch (e) {
    console.log("WS: Nutze Lokale Testdaten");
     } finally {}

    let fetch_drnID= drnID
    let urltoken = "&token="+ token
    let timeZone = "&timeZone="+ formattedOffset
    let apicall = fetchurl+fetch_drnID+urltoken+timeZone
  
    try {
      const response = await fetch(apicall);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const pdfBlob = await response.blob();
      const newFilename = meetingtitle+"_"+now.format('DD:MM:YYYY HH:mm:ss')+".pdf";

      const link = document.createElement('a');
      link.href = URL.createObjectURL(pdfBlob);
      link.download = newFilename;
      link.click();

      setPdfloader(false)

    } catch (error) {
      console.error('Error fetching and opening PDF:', error);
    }
  };


  const fetchZip = async (drnID:any) => {
    
    setZiploader(true)

    let fetchurl
    try {
    if (config.downloadUrlZip !== undefined) {
        fetchurl = config.downloadUrlZip
     } else {
    fetchurl = "https://notarcms-hub.dev.lilenium.com/api/Meeting/zipAllSignedPdf?drnId="
    throw new Error ("WS: Keine Docker Umgebunsvariablen gefunden!");
    }
    } catch (e) {
    console.log("WS: Nutze Lokale Testdaten");
     } finally {}

    let fetch_drnID= drnID
    let urltoken = "&token="+ token
    let timeZone = "&timeZone="+ formattedOffset
    let apicall = fetchurl+fetch_drnID+urltoken+timeZone
  
    try {
      const response = await fetch(apicall);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const pdfBlob = await response.blob();
      const newFilename = meetingtitle+"_"+now.format('DD:MM:YYYY HH:mm:ss')+".zip";

      const link = document.createElement('a');
      link.href = URL.createObjectURL(pdfBlob);
      link.download = newFilename;
      link.click();
      setZiploader(false)

    } catch (error) {
      console.error('Error fetching and opening PDF:', error);
    }
  };


  const rows = (logs || []).map((item:any, index:any) => {
     let datum = dayjs(item.datum).format('DD.MM.YYYY') 
     let datum1 = dayjs(item.datum).format('HH:mm:ss') 
     let icon = <User size={iconsize} color={'#0C3749'} />
     let user
     let span = 3

     if (screenWidth <= 1200){
      iconsize = 15
     }
     
     if (item.actorUserRole === "notar"){
       icon = <User color={'#D1833F'} size={iconsize} />
       user = intl.get('SHOWLOGS_TAB_USER_N')
     } else if (item.actorUserRole === "user"){
       user = intl.get('SHOWLOGS_TAB_USER_K')
     } else if (item.actorUserRole === "gast"){
      icon = <User color={'#a7b1b5'} size={iconsize} />
      user = "Gast"
      span = 5
    }



/*
     let szeneicon
     if (item.currentSceneName !== null){
      if (item.currentSceneName === "Begrüßung"){
      szeneicon = <HeartHandshake size={iconsize}/>
      }
      if (item.currentSceneName === "Identitätsfeststellung"){
        szeneicon = <Camera size={iconsize}/>
      }
      if (item.currentSceneName === "Vorlesung"){
        szeneicon = <Article size={iconsize}/>
      }
      if (item.currentSceneName === "Unterschriften"){
        szeneicon = <Pencil size={iconsize}/>
      }
      if (item.currentSceneName === "Verabschiedung"){
        szeneicon = <Logout size={iconsize}/>
      }

      if (screenWidth <= 1200){
        szeneicon= ""
      }
    }
*/
   

   return (
    <React.Fragment key={item.id || index}>

   <Grid key={index} className={classes.grid_f_size}>
   <Grid.Col span={2}> 

      <Group>{datum}<br />{datum1}</Group>
   </Grid.Col>
   {item.actorUserRole !== "gast" && 
   <Grid.Col span={2}>
      <Group> {item.actorUserId}</Group>
   </Grid.Col>
   }
   <Grid.Col span={span}> 
     {item.actorUserLastName !== null && item.actorUserRole !== "gast" &&
      <Group>{item.actorUserLastName}, {item.actorUserFirstName}  </Group>
    }
    {item.actorUserLastName !== null && item.actorUserRole === "gast" &&
      <Group>{item.actorUserId}  </Group>
    }
   </Grid.Col>
   <Grid.Col span={2}> 
      <Group>{icon}  {user}</Group>
   </Grid.Col>
   <Grid.Col span={3}> 
      <Group> {item.action}</Group>
   </Grid.Col>
   
 </Grid>

 </React.Fragment>
   );
 });


  return (
    <>
     <Space h="xl" />
    <Paper shadow="xs" p="md">
    <Grid >
   <Grid.Col span={12}> 
        <strong>{intl.get('SHOWLOGS_HEAD')} {meetingtitle}</strong><br />
        {intl.get('SHOWLOGS_TEXT')} <strong>{meetingtitle}</strong> / {intl.get('SHOWLOGS_TEXT1')} : <strong>{drnID}</strong> / {intl.get('SHOWLOGS_TEXT2')}: <strong>{meetingId}</strong>  {intl.get('SHOWLOGS_TEXT3')} <strong>{now.format('DD.MM.YYYY HH:mm:ss') }</strong> 
    </Grid.Col>
    <Grid.Col lg={3} md={3} sm={12} xs={12}> 
    <strong>{intl.get('SHOWLOGS_HEAD_PROT')}:</strong>
    </Grid.Col>
    <Grid.Col lg={3} md={3} sm={12} xs={12}> 
    <Button fullWidth color="green" onClick={()=>fetchPdf(drnID)} loading={pdfloader}>{intl.get('SHOWLOGS_BUTTON_PDF')}</Button>
    </Grid.Col>
    <Grid.Col lg={3} md={3} sm={12} xs={12}>
    <Button fullWidth color="green" onClick={()=>fetchZip(drnID)} loading={ziploader}>{intl.get('SHOWLOGS_BUTTON_ZIP')}</Button>
    </Grid.Col>
    <Grid.Col lg={3} md={3} sm={12} xs={12}>
    <Button fullWidth color="gray" onClick={()=>closelog()}>{intl.get('SHOWLOGS_BUTTON_CLOSE')}</Button>
   
    </Grid.Col>
    </Grid>
    </Paper>
<hr />
<Paper shadow="xs" p="md">
<Grid className={classes.grid_f_size}>
   <Grid.Col span={2} > 
      <Group><Clock /> {intl.get('SHOWLOGS_TAB_DATE')}</Group>
   </Grid.Col>
   <Grid.Col span={2}> 
      <Group> {intl.get('SHOWLOGS_TAB_NUTZER')}</Group>
   </Grid.Col>
   <Grid.Col span={3}> 
      <Group> {intl.get('SHOWLOGS_TAB_NAME')}</Group>
   </Grid.Col>
   <Grid.Col span={2}> 
      <Group><User size={iconsize}/> {intl.get('SHOWLOGS_TAB_ROLLE')}</Group>
   </Grid.Col>
   <Grid.Col span={3}> 
      <Group><Activity size={iconsize}/> {intl.get('SHOWLOGS_TAB_AKTIV')}</Group>
   </Grid.Col>
   
 </Grid>
</Paper>
 <hr /> 
 <Paper shadow="xs" p="md">
 <ScrollArea h={750} type="never">
    {rows}
</ScrollArea>
</Paper>
   
    </>
  );
}